import { render, staticRenderFns } from "./TabTerms.vue?vue&type=template&id=a0b64d76&scoped=true&"
import script from "./TabTerms.vue?vue&type=script&lang=js&"
export * from "./TabTerms.vue?vue&type=script&lang=js&"
import style0 from "./TabTerms.vue?vue&type=style&index=0&id=a0b64d76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b64d76",
  null
  
)

export default component.exports